
export const sendMail = (mail, data) => {

    let url = new URL('https://oleoval.miutech.fr/mailsendapi/')
    url.searchParams.append("mail", mail);
    for (const key in data) {
        url.searchParams.append(key, data[key]);
    }
    return fetch(url.toString())
}